export default {
  items: [
    {
      name: "Công ty",
      url: "/admin/System/Company/list",
      icon: "isax-building",
      meta: {
        allowAccess: ["AdminSystem", "Customer"],
        page: "admin",
        code: ["FT001", "FT002", "FT003", "FT004", "FT2302", "FT2303", "FT2304", "FT2305", "FT2306"],
        collection: 'Company'
      }
    },
    {
      name: "Chi nhánh",
      url: "/admin/System/Branch/list",
      icon: "isax-transaction-minus",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Phòng ban",
      url: "/admin/System/Department/list",
      icon: "isax-triangle",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Chức vụ",
      url: "/admin/System/Position/list",
      icon: "isax-user-octagon",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Trợ cấp",
      url: "/admin/System/SubsidiesSalaryType/list",
      icon: "isax-wallet-money",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Hệ số lương",
      url: "/admin/System/CoefficientSalary/list",
      icon: "isax-wallet-minus",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Loại hợp đồng",
      url: "/admin/System/ContractType/list",
      icon: "isax-paperclip",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Chuyên ngành",
      url: "/admin/System/Major/list",
      icon: "isax-verify",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Trình độ",
      url: "/admin/System/Qualification/list",
      icon: "isax-stickynote",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Bậc lương",
      url: "/admin/System/RankSalary/list",
      icon: "isax-wallet-3",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Quan hệ",
      url: "/admin/System/Relationship/list",
      icon: "isax-firstline",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Lý do",
      url: "/admin/System/RequestReason/list",
      icon: "isax-smileys",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT601"]
      }
    },
    {
      name: "Ngày nghỉ",
      url: "/admin/System/DayOffCommon/list",
      icon: "isax-toggle-off-circle",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT407"]
      }
    },
    {
      name: "Loại công việc",
      url: "/admin/System/TaskType/list",
      icon: "isax-document-text",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT501"]
      }
    },
    {
      name: "Quyền",
      url: "/admin/System/Role/list",
      icon: "isax-user-minus",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["FT1301"]
      }
    },
    {
      name: "Phân quyền",
      url: "/admin/RoleFeature/list",
      icon: "isax-scanning",
      meta: {
        allowAccess: ["AdminSystem"],
        page: "admin",
        code: ["*"]
      }
    },
    // {
    //   name: "Module",
    //   url: "/admin/ModuleConfig",
    //   icon: "icon-Home",
    //   meta: {
    //     allowAccess: ["AdminSystem"],
    //     page: "admin",
    //     code: ["*"]
    //   }
    // },
  ]
};
